import {get, post} from 'external/axios';

export class PurchaseService {
	async createPurchase(request) {
		return post('/homeschooler/purchase/create', request);
	}

	async getTransactions() {
		return get('/homeschooler/purchase/getTransactions');
	}

	async getTransactionByClientId(clientId) {
		return get(`homeschooler/purchase/getTransactions/client/${clientId}`);
	}

	async getPurchaseCourses(purchaseItemId) {
		return get(`/homeschooler/purchase/courses/${purchaseItemId}`)
	}
	
	async getPurchaseItemUsers(purchaseItemId) {
		return get(`/homeschooler/purchase/purchaseItemUsers/${purchaseItemId}`)
	}

	async assignPurchaseItemUser(request) {
		return post('/homeschooler/purchaseItem/assignUser', request)
	}

	async createPurchaseItemUser(request) {
		return post('/homeschooler/purchaseItem/create', request)
	}

	async updatePurchaseItemUser(request) {
		return post('/homeschooler/purchaseItem/update', request)
	}
}

export const purchaseService = new PurchaseService();
